import { css } from 'lit';
const styles = css`@charset "UTF-8";
.cre8-u-content-knockout-brand {
  color: var(----cre8-color-content-knockout-brand);
}

.cre8-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

.cre8-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

@media all and (min-width: 23.4375rem) {
  .cre8-u-hide-sm {
    display: none !important;
  }
}
@media all and (min-width: 35rem) {
  .cre8-u-hide-sm-2 {
    display: none !important;
  }
}
@media all and (min-width: 48rem) {
  .cre8-u-hide-md {
    display: none !important;
  }
}
@media all and (min-width: 60rem) {
  .cre8-u-hide-lg {
    display: none !important;
  }
}
@media all and (min-width: 75rem) {
  .cre8-u-hide-xl {
    display: none !important;
  }
}
@media all and (max-width: 23.4375rem) {
  .cre8-u-show-sm {
    display: none !important;
  }
}
@media all and (max-width: 35rem) {
  .cre8-u-show-sm-2 {
    display: none !important;
  }
}
@media all and (max-width: 48rem) {
  .cre8-u-show-md {
    display: none !important;
  }
}
@media all and (max-width: 60rem) {
  .cre8-u-show-lg {
    display: none !important;
  }
}
@media all and (max-width: 75rem) {
  .cre8-u-show-xl {
    display: none !important;
  }
}
.cre8-u-margin-none {
  margin: 0 !important;
}

.cre8-u-margin-sm {
  margin: size(1) !important;
}

.cre8-u-margin-md {
  margin: size(2) !important;
}

.cre8-u-margin-lg {
  margin: size(3) !important;
}

.cre8-u-margin-xl {
  margin: size(4) !important;
}

.cre8-u-margin-xxl {
  margin: size(8) !important;
}

.cre8-u-margin-top-none {
  margin-top: 0 !important;
}

.cre8-u-margin-top-sm {
  margin-top: size(1) !important;
}

.cre8-u-margin-top-md {
  margin-top: size(2) !important;
}

.cre8-u-margin-top-lg {
  margin-top: size(3) !important;
}

.cre8-u-margin-top-xl {
  margin-top: size(4) !important;
}

.cre8-u-margin-top-xxl {
  margin-top: size(8) !important;
}

.cre8-u-margin-right-none {
  margin-right: 0 !important;
}

.cre8-u-margin-right-sm {
  margin-right: size(1) !important;
}

.cre8-u-margin-right-md {
  margin-right: size(2) !important;
}

.cre8-u-margin-right-lg {
  margin-right: size(3) !important;
}

.cre8-u-margin-right-xl {
  margin-right: size(4) !important;
}

.cre8-u-margin-right-xxl {
  margin-right: size(8) !important;
}

.cre8-u-margin-bottom-none {
  margin-bottom: 0 !important;
}

.cre8-u-margin-bottom-sm {
  margin-bottom: size(1) !important;
}

.cre8-u-margin-bottom-md {
  margin-bottom: size(2) !important;
}

.cre8-u-margin-bottom-lg {
  margin-bottom: size(3) !important;
}

.cre8-u-margin-bottom-xl {
  margin-bottom: size(4) !important;
}

.cre8-u-margin-bottom-xxl {
  margin-bottom: size(8) !important;
}

.cre8-u-margin-bottom-xl-xxl {
  margin-bottom: size(4) !important;
}

@media all and (min-width: 768px) {
  .cre8-u-margin-bottom-xl-xxl {
    margin-bottom: size(8) !important;
  }
}
.cre8-u-margin-left-none {
  margin-left: 0 !important;
}

.cre8-u-margin-left-sm {
  margin-left: size(1) !important;
}

.cre8-u-margin-left-md {
  margin-left: size(2) !important;
}

.cre8-u-margin-left-lg {
  margin-left: size(3) !important;
}

.cre8-u-margin-left-xl {
  margin-left: size(4) !important;
}

.cre8-u-margin-left-xxl {
  margin-left: size(8) !important;
}

.cre8-u-padding-none {
  padding: 0 !important;
}

.cre8-u-padding-sm {
  padding: size(1) !important;
}

.cre8-u-padding-md {
  padding: size(2) !important;
}

.cre8-u-padding-lg {
  padding: size(3) !important;
}

.cre8-u-padding-xl {
  padding: size(4) !important;
}

.cre8-u-padding-xxl {
  padding: size(8) !important;
}

.cre8-u-padding-top-none {
  padding-top: 0 !important;
}

.cre8-u-padding-top-sm {
  padding-top: size(1) !important;
}

.cre8-u-padding-top-md {
  padding-top: size(2) !important;
}

.cre8-u-padding-top-lg {
  padding-top: size(3) !important;
}

.cre8-u-padding-top-xl {
  padding-top: size(4) !important;
}

.cre8-u-padding-top-xxl {
  padding-top: size(8) !important;
}

.cre8-u-padding-right-none {
  padding-right: 0 !important;
}

.cre8-u-padding-right-sm {
  padding-right: size(1) !important;
}

.cre8-u-padding-right-md {
  padding-right: size(2) !important;
}

.cre8-u-padding-right-lg {
  padding-right: size(3) !important;
}

.cre8-u-padding-right-xl {
  padding-right: size(4) !important;
}

.cre8-u-padding-right-xxl {
  padding-right: size(8) !important;
}

.cre8-u-padding-bottom-none {
  padding-bottom: 0 !important;
}

.cre8-u-padding-bottom-sm {
  padding-bottom: size(1) !important;
}

.cre8-u-padding-bottom-md {
  padding-bottom: size(2) !important;
}

.cre8-u-padding-bottom-lg {
  padding-bottom: size(3) !important;
}

.cre8-u-padding-bottom-xl {
  padding-bottom: size(4) !important;
}

.cre8-u-padding-bottom-xxl {
  padding-bottom: size(8) !important;
}

.cre8-u-padding-left-none {
  padding-left: 0 !important;
}

.cre8-u-padding-left-sm {
  padding-left: size(1) !important;
}

.cre8-u-padding-left-md {
  padding-left: size(2) !important;
}

.cre8-u-padding-left-lg {
  padding-left: size(3) !important;
}

.cre8-u-padding-left-xl {
  padding-left: size(4) !important;
}

.cre8-u-padding-left-xxl {
  padding-left: size(8) !important;
}

.cre8-u-display-flex {
  display: flex !important;
}

.cre8-u-display-block {
  display: block !important;
}

body {
  font-family: var(--cre8-typography-body-default-font-family);
  font-size: var(--cre8-typography-body-default-font-size);
  font-weight: var(--cre8-typography-body-default-font-weight);
  line-height: var(--cre8-typography-body-default-line-height);
  -webkit-text-decoration: var(--cre8-typography-body-default-text-decoration);
  text-decoration: var(--cre8-typography-body-default-text-decoration);
  text-transform: var(--cre8-typography-body-default-text-transform);
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  color: var(--cre8-color-content-default);
  background: var(--background-default);
}

@media all and (min-width: 60rem) {
  .page-container {
    background: linear-gradient(90deg, #fff 0, #fff 66.66%, #f8f8f9 0, #f8f8f9 0);
  }
}
.band__inner {
  margin-left: 2rem;
  margin-right: 2rem;
}

@media all and (min-width: 60rem) {
  .band__inner {
    margin-right: 0;
  }
}
img {
  max-width: 100%;
  height: auto;
}

/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:root {
  --size-base-unit: 0.5rem;
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to-right" or "to-left" need to be switched to using deg values.
 * 3) Inverse items that have 45degs
 */
[dir=rtl] {
  --rtlTranslateX: 50%;
  /* 1 */
  --rtlGradientToRight: 270deg;
  /* 2 */
  --rtlRotate45Inverse: -45deg;
  /* 3 */
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements with an error status
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
* Focus state for themes that need a dashed outline for focus
* state
**/
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
/*
=======
Animations
=======
*/
:host {
  --cre8-z-index-1: 1;
  --cre8-z-index-50: 50;
  --cre8-z-index-100: 100;
  --cre8-z-index-200: 200;
  --cre8-z-index-1030: 1030;
  --cre8-anim-fade-quick: 0.35s;
  --cre8-anim-ease: ease;
}

@keyframes fadeIn {
  100% {
    opacity: 1;
  }
}
@keyframes slideIn {
  100% {
    transform: translateX(0);
  }
}
@keyframes slideInFwd {
  100% {
    width: 272px;
    height: 272px;
  }
}
@keyframes slideOutRight {
  100% {
    width: 272px;
    height: 272px;
  }
}
@keyframes slideUp {
  100% {
    transform: translateY(0);
  }
}
@media (width >= 481px) {
  @keyframes slideInFwd {
    100% {
      width: 417px;
      height: 417px;
    }
  }
  @keyframes slideOutRight {
    100% {
      width: 417px;
      height: 417px;
    }
  }
}
@media (width >= 48rem) {
  @keyframes slideInFwd {
    100% {
      width: 330px;
      height: 330px;
    }
  }
  @keyframes slideOutRight {
    100% {
      width: 330px;
      height: 330px;
      transform: translateX(calc(100vw - 45px));
    }
  }
}
@media (width >= 60rem) {
  @keyframes slideInFwd {
    100% {
      width: 460px;
      height: 460px;
    }
  }
  @keyframes slideOutRight {
    100% {
      width: 460px;
      height: 460px;
      transform: translateX(calc(100vw - 45px));
    }
  }
}
@media (width >= 75rem) {
  @keyframes slideInFwd {
    100% {
      width: 592px;
      height: 591px;
    }
  }
  @keyframes slideOutRight {
    100% {
      width: 592px;
      height: 591px;
      transform: translateX(calc(100vw - 45px));
    }
  }
}
@media (width >= 87.5rem) {
  @keyframes slideOutRight {
    100% {
      width: 592px;
      height: 591px;
      transform: translateX(calc(100vw - 120px));
    }
  }
}
@media (width >= 2200px) {
  @keyframes slideOutRight {
    100% {
      width: 592px;
      height: 591px;
      transform: translateX(calc(100vw - 592px));
    }
  }
}
span.ripple {
  position: absolute;
  border-radius: 50%;
  transform: scale(0);
  animation: ripple 600ms linear;
  background-color: var(--ripple-bg-color);
}

@keyframes ripple {
  to {
    transform: scale(4);
    opacity: 1;
  }
}
:root {
  --size-base-unit: 0.5rem;
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to-right" or "to-left" need to be switched to using deg values.
 * 3) Inverse items that have 45degs
 */
[dir=rtl] {
  --rtlTranslateX: 50%;
  /* 1 */
  --rtlGradientToRight: 270deg;
  /* 2 */
  --rtlRotate45Inverse: -45deg;
  /* 3 */
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements with an error status
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
* Focus state for themes that need a dashed outline for focus
* state
**/
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
:host {
  display: inline-flex;
}

:host([fullWidth]) {
  display: flex;
}

/**
 * 1) Danger Button or link that has functionality to it
 */
/**
 * Primary button
 */
.cre8-c-danger-button {
  font-family: var(--cre8-typography-label-default-font-family);
  font-size: var(--cre8-typography-label-default-font-size);
  font-weight: var(--cre8-typography-label-default-font-weight);
  line-height: var(--cre8-typography-label-default-line-height);
  text-decoration: var(--cre8-typography-label-default-text-decoration);
  text-transform: var(--cre8-typography-label-default-text-transform);
  width: var(--cre8-button-width, auto);
  height: var(--cre8-button-height, auto);
  min-width: var(--cre8-button-min-width, auto);
  min-height: var(--cre8-button-min-height, auto);
  justify-content: center;
  text-align: center;
  margin-top: var(--cre8-button-margin-top, 0);
  margin-bottom: var(--cre8-button-margin-bottom, 0);
  margin-left: var(--cre8-button-margin-left, 0);
  margin-right: var(--cre8-button-margin-right, 0);
  display: inline-flex;
  align-items: center;
  border-width: var(--cre8-border-width-button-default);
  box-shadow: var(--cre8-shadow-button);
  padding-top: var(--cre8-button-padding-vertical-medium);
  padding-right: var(--cre8-button-padding-horizontal-medium);
  padding-bottom: var(--cre8-button-padding-vertical-medium);
  padding-left: var(--cre8-button-padding-horizontal-medium);
  margin: 0;
  cursor: pointer;
  border-style: var(--cre8-border-style-default);
  transition: revert;
  transform: revert;
  white-space: nowrap;
}
.cre8-c-danger-button:hover, .cre8-c-danger-button:focus, .cre8-c-danger-button:active, .cre8-c-danger-button:focus-visible {
  border-style: var(--cre8-border-style-default);
  box-shadow: none;
  transform: revert;
  transition: revert;
}
.cre8-c-danger-button.cre8-c-danger-button--primary {
  background: var(--cre8-color-button-primary-danger-bg);
  border-width: var(--cre8-border-width-button-default);
  border-color: var(--cre8-color-button-primary-danger-border);
  border-radius: var(--cre8-border-radius-button);
  box-shadow: var(--cre8-shadow-button);
  color: var(--cre8-color-button-primary-danger-content);
  --cre8-icon-fill: var(--cre8-color-button-primary-danger-content);
}
.cre8-c-danger-button.cre8-c-danger-button--primary:hover, .cre8-c-danger-button.cre8-c-danger-button--primary:focus {
  box-shadow: none;
  --cre8-icon-fill: var(--cre8-color-button-primary-danger-content-hover);
  color: var(--cre8-color-button-primary-danger-content-hover);
  border-color: var(--cre8-color-button-primary-danger-border-hover);
  background: var(--cre8-color-button-primary-danger-bg-hover);
  text-decoration: none;
}
.cre8-c-danger-button.cre8-c-danger-button--primary:hover:focus, .cre8-c-danger-button.cre8-c-danger-button--primary:focus:focus {
  outline: var(--cre8-border-width-focus) solid var(--cre8-color-border-active-outline);
  outline-offset: 0.125rem;
}
.cre8-c-danger-button.cre8-c-danger-button--primary:active, .cre8-c-danger-button.cre8-c-danger-button--primary.cre8-c-danger-button--loading {
  box-shadow: none;
  color: var(--cre8-color-button-primary-danger-content-active);
  --cre8-icon-fill: var(--cre8-color-button-primary-danger-content-active);
  border-color: var(--cre8-color-button-primary-danger-border-active);
  background-color: var(--cre8-color-button-primary-danger-bg-active);
}
.cre8-c-danger-button.cre8-c-danger-button--primary:focus-visible {
  outline: var(--cre8-border-width-focus) solid var(--cre8-color-border-active-outline);
  outline-offset: 0.125rem;
}
.cre8-c-danger-button.cre8-c-danger-button--primary.cre8-c-danger-button--loading {
  cursor: not-allowed;
}
.cre8-c-danger-button.cre8-c-danger-button--primary {
  /**
  * Disabled primary and secondary button
  */
}
.cre8-c-danger-button.cre8-c-danger-button--primary:disabled {
  box-shadow: none;
  background-color: var(--cre8-color-button-primary-danger-bg-disabled);
  border-color: var(--cre8-color-button-primary-danger-border-disabled);
  color: var(--cre8-color-button-primary-danger-content-disabled);
  --cre8-icon-fill: var(--cre8-color-button-primary-danger-content-disabled);
  cursor: not-allowed;
  outline: none;
}
.cre8-c-danger-button.cre8-c-danger-button--primary:disabled:hover, .cre8-c-danger-button.cre8-c-danger-button--primary:disabled:focus, .cre8-c-danger-button.cre8-c-danger-button--primary:disabled:active, .cre8-c-danger-button.cre8-c-danger-button--primary:disabled:focus-visible {
  outline: none;
  background-color: var(--cre8-color-button-primary-danger-bg-disabled);
  border-color: var(--cre8-color-button-primary-danger-border-disabled);
  color: var(--cre8-color-button-primary-danger-content-disabled);
  --cre8-icon-fill: var(--cre8-color-button-primary-danger-content-disabled);
}
.cre8-c-danger-button.cre8-c-danger-button--primary.cre8-c-danger-button--inverted {
  background-color: var(--cre8-color-button-primary-danger-inverse-bg);
  border-color: var(--cre8-color-button-primary-danger-inverse-border);
  color: var(--cre8-color-button-primary-danger-inverse-content);
}
.cre8-c-danger-button.cre8-c-danger-button--primary.cre8-c-danger-button--inverted:hover, .cre8-c-danger-button.cre8-c-danger-button--primary.cre8-c-danger-button--inverted:focus {
  background-color: var(--cre8-color-button-primary-danger-inverse-bg-hover);
  border-color: var(--cre8-color-button-primary-danger-inverse-border-hover);
  color: var(--cre8-color-button-primary-danger-inverse-content-hover);
}
.cre8-c-danger-button.cre8-c-danger-button--primary.cre8-c-danger-button--inverted:focus {
  outline-color: var(--cre8-color-button-primary-danger-inverse-outline);
}
.cre8-c-danger-button.cre8-c-danger-button--primary.cre8-c-danger-button--inverted:active {
  background-color: var(--cre8-color-button-primary-danger-inverse-bg-active);
  border-color: var(--cre8-color-button-primary-danger-inverse-border-active);
  color: var(--cre8-color-button-primary-danger-inverse-content-active);
}
.cre8-c-danger-button.cre8-c-danger-button--primary.cre8-c-danger-button--inverted:active.cre8-c-danger-button--loading {
  --cre8-icon-fill: var(--cre8-color-button-primary-danger-content-active);
}
.cre8-c-danger-button.cre8-c-danger-button--primary.cre8-c-danger-button--inverted:disabled {
  outline: none;
  cursor: not-allowed;
  background-color: var(--cre8-color-button-primary-danger-inverse-bg-disabled);
  border-color: var(--cre8-color-button-primary-danger-inverse-border-disabled);
  color: var(--cre8-color-button-primary-danger-inverse-content-disabled);
}
.cre8-c-danger-button {
  /**
  * Secondary button
  * The icon button shares the styles of the standard secondary button
  */
}
.cre8-c-danger-button.cre8-c-danger-button--secondary {
  background-color: var(--cre8-color-button-secondary-danger-bg);
  border-color: var(--cre8-color-button-secondary-danger-border);
  color: var(--cre8-color-button-secondary-danger-content);
  --cre8-icon-fill: var(--cre8-color-button-secondary-danger-content);
  border-radius: var(--cre8-border-radius-button);
  border-width: var(--cre8-border-width-button-default);
}
.cre8-c-danger-button.cre8-c-danger-button--secondary:hover, .cre8-c-danger-button.cre8-c-danger-button--secondary:focus {
  background-color: var(--cre8-color-button-secondary-danger-bg-hover);
  border-color: var(--cre8-color-button-secondary-danger-border-hover);
  color: var(--cre8-color-button-secondary-danger-content-hover);
  --cre8-icon-fill: var(--cre8-color-button-secondary-danger-content-hover);
}
.cre8-c-danger-button.cre8-c-danger-button--secondary:hover:focus, .cre8-c-danger-button.cre8-c-danger-button--secondary:focus:focus {
  outline: var(--cre8-border-width-focus) solid var(--cre8-color-border-active-outline);
  outline-offset: 0.125rem;
}
.cre8-c-danger-button.cre8-c-danger-button--secondary:active, .cre8-c-danger-button.cre8-c-danger-button--secondary.cre8-c-danger-button--loading {
  transition: none;
  transform: none;
  background-color: var(--cre8-color-button-secondary-danger-bg-active);
  border-color: var(--cre8-color-button-secondary-danger-border-active);
  color: var(--cre8-color-button-secondary-danger-content-active);
  --cre8-icon-fill: var(--cre8-color-button-secondary-danger-content-active);
}
.cre8-c-danger-button.cre8-c-danger-button--secondary:focus-visible {
  outline: var(--cre8-border-width-focus) solid var(--cre8-color-border-active-outline);
  outline-offset: 0.125rem;
}
.cre8-c-danger-button.cre8-c-danger-button--secondary.cre8-c-danger-button--loading {
  cursor: not-allowed;
}
.cre8-c-danger-button.cre8-c-danger-button--secondary:disabled {
  box-shadow: none;
  background-color: var(--cre8-color-button-secondary-danger-bg-disabled);
  border-color: var(--cre8-color-button-secondary-danger-border-disabled);
  color: var(--cre8-color-button-secondary-danger-content-disabled);
  --cre8-icon-fill: var(--cre8-color-button-secondary-danger-content-disabled);
  outline: none;
  border-radius: var(--cre8-border-radius-button);
  border-width: var(--cre8-border-width-button-default);
  cursor: not-allowed;
}
.cre8-c-danger-button.cre8-c-danger-button--secondary:disabled:hover, .cre8-c-danger-button.cre8-c-danger-button--secondary:disabled:focus, .cre8-c-danger-button.cre8-c-danger-button--secondary:disabled:active, .cre8-c-danger-button.cre8-c-danger-button--secondary:disabled:focus-visible {
  outline: none;
  background-color: var(--cre8-color-button-secondary-danger-bg-disabled);
  border-color: var(--cre8-color-button-secondary-danger-border-disabled);
  color: var(--cre8-color-button-secondary-danger-content-disabled);
  --cre8-icon-fill: var(--cre8-color-button-secondary-danger-content-disabled);
}
.cre8-c-danger-button.cre8-c-danger-button--secondary.cre8-c-danger-button--inverted {
  background-color: var(--cre8-color-button-secondary-danger-inverse-bg);
  border-color: var(--cre8-color-button-secondary-danger-inverse-border);
  color: var(--cre8-color-button-secondary-danger-inverse-content);
}
.cre8-c-danger-button.cre8-c-danger-button--secondary.cre8-c-danger-button--inverted:hover, .cre8-c-danger-button.cre8-c-danger-button--secondary.cre8-c-danger-button--inverted:focus {
  background-color: var(--cre8-color-button-secondary-danger-inverse-bg-hover);
  border-color: var(--cre8-color-button-secondary-danger-inverse-border-hover);
  color: var(--cre8-color-button-secondary-danger-inverse-content-hover);
}
.cre8-c-danger-button.cre8-c-danger-button--secondary.cre8-c-danger-button--inverted:focus {
  outline-color: var(--cre8-color-button-secondary-danger-inverse-outline);
}
.cre8-c-danger-button.cre8-c-danger-button--secondary.cre8-c-danger-button--inverted:active {
  background-color: var(--cre8-color-button-secondary-danger-inverse-bg-active);
  border-color: var(--cre8-color-button-secondary-danger-inverse-border-active);
  color: var(--cre8-color-button-secondary-danger-inverse-content-active);
}
.cre8-c-danger-button.cre8-c-danger-button--secondary.cre8-c-danger-button--inverted:active.cre8-c-danger-button--loading {
  --cre8-icon-fill: var(--cre8-color-button-secondary-danger-content-active);
}
.cre8-c-danger-button.cre8-c-danger-button--secondary.cre8-c-danger-button--inverted:disabled {
  outline: none;
  cursor: not-allowed;
  background-color: var(--cre8-color-button-secondary-danger-inverse-bg-disabled);
  border-color: var(--cre8-color-button-secondary-danger-inverse-border-disabled);
  color: var(--cre8-color-button-secondary-danger-inverse-content-disabled);
}
.cre8-c-danger-button {
  /**
  * Tertiary button
  */
}
.cre8-c-danger-button.cre8-c-danger-button--tertiary {
  border-radius: var(--cre8-border-radius-button);
  background-color: var(--cre8-color-button-tertiary-danger-bg);
  border-width: var(--cre8-border-width-button-default);
  border-color: var(--cre8-color-button-tertiary-danger-border);
  color: var(--cre8-color-button-tertiary-danger-content);
  --cre8-icon-fill: var(--cre8-color-button-tertiary-danger-content);
  box-shadow: none;
}
.cre8-c-danger-button.cre8-c-danger-button--tertiary:hover, .cre8-c-danger-button.cre8-c-danger-button--tertiary:focus {
  border-radius: var(--cre8-border-radius-button);
  background-color: var(--cre8-color-button-tertiary-danger-bg-hover);
  border-width: var(--cre8-border-width-button-default, --cre8-border-width-none);
  border-color: var(--cre8-color-button-tertiary-danger-border-hover);
  color: var(--cre8-color-button-tertiary-danger-content-hover);
  --cre8-icon-fill: var(--cre8-color-button-tertiary-danger-content-hover);
}
.cre8-c-danger-button.cre8-c-danger-button--tertiary:hover:focus, .cre8-c-danger-button.cre8-c-danger-button--tertiary:focus:focus {
  outline: var(--cre8-border-width-focus) var(--cre8-border-style-button-tertiary-outline-focus) var(--cre8-color-border-active-outline);
  outline-offset: 0.125rem;
}
.cre8-c-danger-button.cre8-c-danger-button--tertiary:active, .cre8-c-danger-button.cre8-c-danger-button--tertiary.cre8-c-danger-button--loading {
  border-radius: var(--cre8-border-radius-button);
  background-color: var(--cre8-color-button-tertiary-danger-bg-active);
  border-color: var(--cre8-color-button-tertiary-danger-border-active);
  border-width: var(--cre8-border-width-button-default);
  color: var(--cre8-color-button-tertiary-danger-content-active);
  --cre8-icon-fill: var(--cre8-color-button-tertiary-danger-content-active);
}
.cre8-c-danger-button.cre8-c-danger-button--tertiary:focus-visible {
  outline: var(--cre8-border-width-focus) var(--cre8-border-style-button-tertiary-outline-focus) var(--cre8-color-border-active-outline);
  outline-offset: 0.125rem;
}
.cre8-c-danger-button.cre8-c-danger-button--tertiary.cre8-c-danger-button--loading {
  cursor: not-allowed;
}
.cre8-c-danger-button.cre8-c-danger-button--tertiary:disabled {
  background-color: var(--cre8-color-button-tertiary-danger-bg-disabled);
  border-color: transparent;
  color: var(--cre8-color-button-tertiary-danger-content-disabled);
  --cre8-icon-fill: var(--cre8-color-button-tertiary-danger-content-disabled);
  outline: none;
  box-shadow: none;
  cursor: not-allowed;
}
.cre8-c-danger-button.cre8-c-danger-button--tertiary:disabled:hover, .cre8-c-danger-button.cre8-c-danger-button--tertiary:disabled:focus {
  outline: none;
  box-shadow: none;
  background-color: var(--cre8-color-button-tertiary-danger-bg-disabled);
  color: var(--cre8-color-button-tertiary-danger-content-disabled);
  --cre8-icon-fill: var(--cre8-color-button-tertiary-danger-content-disabled);
}
.cre8-c-danger-button.cre8-c-danger-button--tertiary:disabled:active, .cre8-c-danger-button.cre8-c-danger-button--tertiary:disabled:focus-visible {
  outline: none;
  box-shadow: none;
  background-color: var(--cre8-color-button-tertiary-danger-bg-disabled);
  color: var(--cre8-color-button-tertiary-danger-content-disabled);
  --cre8-icon-fill: var(--cre8-color-button-tertiary-danger-content-disabled);
}
.cre8-c-danger-button.cre8-c-danger-button--tertiary.cre8-c-danger-button--inverted {
  background-color: var(--cre8-color-button-tertiary-danger-inverse-bg);
  border-color: var(--cre8-color-button-tertiary-danger-inverse-border);
  color: var(--cre8-color-button-tertiary-danger-inverse-content);
}
.cre8-c-danger-button.cre8-c-danger-button--tertiary.cre8-c-danger-button--inverted:hover, .cre8-c-danger-button.cre8-c-danger-button--tertiary.cre8-c-danger-button--inverted:focus {
  background-color: var(--cre8-color-button-tertiary-danger-inverse-bg-hover);
  border-color: var(--cre8-color-button-tertiary-danger-inverse-border-hover);
  color: var(--cre8-color-button-tertiary-danger-inverse-content-hover);
}
.cre8-c-danger-button.cre8-c-danger-button--tertiary.cre8-c-danger-button--inverted:focus {
  outline-color: var(--cre8-color-button-tertiary-danger-inverse-outline);
}
.cre8-c-danger-button.cre8-c-danger-button--tertiary.cre8-c-danger-button--inverted:active {
  background-color: var(--cre8-color-button-tertiary-danger-inverse-bg-active);
  border-color: var(--cre8-color-button-tertiary-danger-inverse-border-active);
  color: var(--cre8-color-button-tertiary-danger-inverse-content-active);
}
.cre8-c-danger-button.cre8-c-danger-button--tertiary.cre8-c-danger-button--inverted:active.cre8-c-danger-button--loading {
  --cre8-icon-fill: var(--cre8-color-button-tertiary-danger-content-active);
}
.cre8-c-danger-button.cre8-c-danger-button--tertiary.cre8-c-danger-button--inverted:disabled {
  outline: none;
  cursor: not-allowed;
  background-color: var(--cre8-color-button-tertiary-danger-inverse-bg-disabled);
  border-color: var(--cre8-color-button-tertiary-danger-inverse-border-disabled);
  color: var(--cre8-color-button-tertiary-danger-inverse-content-disabled);
}
.cre8-c-danger-button.cre8-c-danger-button.cre8-c-danger-button--secondary.cre8-c-danger-button--split-button-text {
  border-radius: var(--cre8-border-radius-button) var(--cre8-border-radius-none) var(--cre8-border-radius-none) var(--cre8-border-radius-button);
  border-color: var(--cre8-color-button-secondary-danger-border);
  border-width: var(--cre8-border-width-button-default);
  color: var(--cre8-color-button-secondary-danger-content);
}
.cre8-c-danger-button.cre8-c-danger-button.cre8-c-danger-button--secondary.cre8-c-danger-button--split-button-text:active, .cre8-c-danger-button.cre8-c-danger-button.cre8-c-danger-button--secondary.cre8-c-danger-button--split-button-text:focus-visible {
  outline: none;
}
.cre8-c-danger-button.cre8-c-danger-button.cre8-c-danger-button--secondary.cre8-c-danger-button--split-button-text.cre8-c-danger-button--lg {
  padding: var(--cre8-button-padding-vertical-large) var(--cre8-button-padding-horizontal-large);
}
.cre8-c-danger-button.cre8-c-danger-button.cre8-c-danger-button--secondary.cre8-c-danger-button--split-button-text.cre8-c-danger-button--sm {
  padding: var(--cre8-button-padding-vertical-small) var(--cre8-button-padding-horizontal-small);
}
.cre8-c-danger-button.cre8-c-danger-button.cre8-c-danger-button--icon-only.cre8-c-danger-button--split-button-caret {
  padding: var(--cre8-button-padding-vertical-medium);
  border-radius: var(--cre8-border-radius-none) var(--cre8-border-radius-button) var(--cre8-border-radius-button) var(--cre8-border-radius-none);
  height: 100%;
  border-left: none !important;
  border-collapse: collapse;
  background: var(--cre8-color-button-secondary-danger-bg);
  border-color: var(--cre8-color-button-secondary-danger-border);
  border-width: var(--cre8-border-width-button-default);
  color: var(--cre8-color-button-secondary-danger-content);
  --cre8-icon-fill: var(--cre8-color-button-secondary-danger-content);
}
.cre8-c-danger-button.cre8-c-danger-button.cre8-c-danger-button--icon-only.cre8-c-danger-button--split-button-caret:hover, .cre8-c-danger-button.cre8-c-danger-button.cre8-c-danger-button--icon-only.cre8-c-danger-button--split-button-caret:focus {
  background: var(--cre8-color-button-secondary-danger-bg-hover);
  border-color: var(--cre8-color-button-secondary-danger-border-hover);
  --cre8-icon-fill: var(--cre8-color-button-secondary-danger-content-hover);
  outline: none;
  border-left: none;
  border-collapse: collapse;
}
.cre8-c-danger-button.cre8-c-danger-button.cre8-c-danger-button--icon-only.cre8-c-danger-button--split-button-caret:active, .cre8-c-danger-button.cre8-c-danger-button.cre8-c-danger-button--icon-only.cre8-c-danger-button--split-button-caret:focus-visible {
  background: var(--cre8-color-button-secondary-danger-bg-active);
  border-color: var(--cre8-color-button-secondary-danger-border-active);
  --cre8-icon-fill: var(--cre8-color-button-secondary-danger-content-active);
  outline: none;
  border-left: none;
  border-collapse: collapse;
}

.cre8-c-danger-button--lg {
  padding: var(--cre8-button-padding-vertical-large);
}

.cre8-c-danger-button--sm {
  padding: var(--cre8-button-padding-vertical-small);
}

.cre8-c-danger-button--icon-only {
  padding: var(--cre8-button-padding-vertical-small);
  color: var(--cre8-icon-fill, currentColor);
}

/**
 * Full-width button
 */
.cre8-c-danger-button--full-width {
  width: 100%;
  display: flex;
}

/**
 * Small button
 */
.cre8-c-danger-button--sm {
  font-family: var(--cre8-typography-label-small-font-family);
  font-size: var(--cre8-typography-label-small-font-size);
  font-weight: var(--cre8-typography-label-small-font-weight);
  line-height: var(--cre8-typography-label-small-line-height);
  text-decoration: var(--cre8-typography-label-small-text-decoration);
  text-transform: var(--cre8-typography-label-small-text-transform);
  padding-top: var(--cre8-button-padding-vertical-small);
  padding-right: var(--cre8-button-padding-horizontal-small);
  padding-bottom: var(--cre8-button-padding-vertical-small);
  padding-left: var(--cre8-button-padding-horizontal-small);
}

/**
 * Large button
 */
.cre8-c-danger-button--lg {
  font-family: var(--cre8-typography-label-large-font-family);
  font-size: var(--cre8-typography-label-large-font-size);
  font-weight: var(--cre8-typography-label-large-font-weight);
  line-height: var(--cre8-typography-label-large-line-height);
  text-decoration: var(--cre8-typography-label-large-text-decoration);
  text-transform: var(--cre8-typography-label-large-text-transform);
  padding-top: var(--cre8-button-padding-vertical-large);
  padding-right: var(--cre8-button-padding-horizontal-large);
  padding-bottom: var(--cre8-button-padding-vertical-large);
  padding-left: var(--cre8-button-padding-horizontal-large);
}

/**
  * Icon within small button
  */
.cre8-c-danger-button--sm cre8-icon {
  --cre8-icon-height: var(--cre8-icon-size-small);
  --cre8-icon-width: var(--cre8-icon-size-small);
  /**
       * Button text directly after button icon within small button
       */
}

/**
  * Icon within large button
  */
.cre8-c-danger-button--lg cre8-icon {
  --cre8-icon-height: var(--cre8-icon-size-large);
  --cre8-icon-width: var(--cre8-icon-size-large);
}

::slotted(*) {
  margin-right: 0;
}

/**
 * Button icon directly before button text
 */
cre8-icon + .cre8-c-danger-button__text:not(.cre8-u-is-vishidden) {
  margin-left: 0.5rem;
  display: inline-flex;
}

/**
   * Button icon directly after button text
   */
.cre8-c-danger-button__text:not(.cre8-u-is-vishidden) + cre8-icon {
  margin-left: 0.5rem;
  display: inline-flex;
}

/**
   * Button icon only
   */
.cre8-c-danger-button:has(.cre8-c-danger-button__text.cre8-u-is-vishidden) + cre8-icon {
  border-radius: var(--cre8-border-radius-button);
}

.cre8-c-danger-button__text.cre8-u-is-vishidden + cre8-icon {
  margin-left: 0px;
  margin-right: 0px;
  display: flex;
}

.cre8-c-danger-button__text.cre8-u-is-vishidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.cre8-c-danger-button--primary.cre8-c-danger-button--loading {
  --cre8-icon-fill: var(--cre8-color-content-knockout);
}

.cre8-c-danger-button--secondary.cre8-c-danger-button--loading,
.cre8-c-danger-button--tertiary.cre8-c-danger-button--loading {
  --cre8-icon-fill: var(--cre8-color-button-secondary-danger-content-active);
}

/**
 * Aria live span
 */
.cre8-u-is-vishidden {
  --cre8-icon-height: 0px;
  --cre8-icon-width: 0px;
  max-width: fit-content;
  min-width: 0px;
  width: auto;
  height: auto;
  max-height: fit-content;
  min-width: 0px;
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

cre8-icon.cre8-u-is-vishidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

cre8-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

span.cre8-c-danger-button__icon {
  margin-left: 0.5rem;
  max-width: fit-content;
  min-width: 0px;
  width: auto;
  height: auto;
  max-height: fit-content;
  min-width: 0px;
}`;
export default styles;
